import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const creditPriceService = {
    getAll,
    getAllCreditPrices,
    addCreditPrice,
    updateCreditPrice,
    deleteCreditPrice,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-prices/getAllCreditPrices/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllCreditPrices() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-prices/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addCreditPrice(newCreditPrice) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newCreditPrice),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-prices/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateCreditPrice(creditPriceItem, creditPriceId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(creditPriceItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-prices/update/${creditPriceId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteCreditPrice(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-prices/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
